export enum WebsiteMode {
  none = 0,
  corporate = 1 << 0,
  consultant = 1 << 1,
  order = 1 << 2,
}
